export const GITLAB_API_CONFIG = {
  URI: 'https://git.gridscale.it',

  get API_URI() {
    return `${GITLAB_API_CONFIG.URI}/api/v4`;
  },

  APP_ID: '42ac2eae287510cd5e43b1580c560043d29cb80c4f65f73912a545b5dc3324c2',
  SECRET: 'gloas-fa22e64fdb24f5042cd93dca9a0f913239eb2bbe91aea0954b5222635fb55f6a',

  PROJECT_ID: 866,
  JSON_PATH: 'json',

  LOCALSTORAGE_KEY: 'hc_gitlab_token',

  get REDIRECT_URI() {
    return window.location.protocol + '//' + window.location.host + location.pathname;
  },

  get TOKEN_ENDPOINT() {
    return `${GITLAB_API_CONFIG.URI}/oauth/token`;
  },

  get AUTH_REQUEST_URI() {
    return `${GITLAB_API_CONFIG.URI}/oauth/authorize?client_id=${GITLAB_API_CONFIG.APP_ID}&redirect_uri=${encodeURIComponent(GITLAB_API_CONFIG.REDIRECT_URI)}&response_type=code&scope=read_api+read_repository`;
  },
} as const;

Object.freeze(GITLAB_API_CONFIG);
